// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal .modal-title[data-v-505a3830]{margin-bottom:0}.modal .modal-header[data-v-505a3830]{padding:10px 30px}.modal .modal-body[data-v-505a3830]{padding:10px 30px 30px}.rating_modal .modal-body .text_field[data-v-505a3830]{margin-bottom:0}.success-result[data-v-505a3830]{line-height:50px;min-width:170px}@media screen and (max-width:768px){.rating_field label[data-v-505a3830]{font-size:12px;line-height:14px}}", ""]);
// Exports
module.exports = exports;
